import React from 'react'
import { Container } from '@chakra-ui/react'

export const ContainerFull = ({ children, ...props }) => {
    return (
        <Container {...props} maxW={'container.full'}>
            {children}
        </Container>
    )
}

export const Container2Xl = ({ children, ...props }) => {
    return (
        <Container {...props} maxW={'container.2xl'}>
            {children}
        </Container>
    )
}

export const ContainerXl = ({ children, ...props }) => {
    return (
        <Container {...props} maxW={'container.xl'}>
            {children}
        </Container>
    )
}

export const ContainerLg = ({ children, ...props }) => {
    return (
        <Container {...props} maxW={'container.lg'}>
            {children}
        </Container>
    )
}

export const ContainerMd = ({ children, ...props }) => {
    return (
        <Container {...props} maxW={'container.md'}>
            {children}
        </Container>
    )
}

export const ContainerSm = ({ children, ...props }) => {
    return (
        <Container {...props} maxW={'container.sm'}>
            {children}
        </Container>
    )
}

ContainerFull.defaultProps = {
    position: 'relative',
    px: 2,
}

Container2Xl.defaultProps = {
    position: 'relative',
    px: 2,
}

ContainerXl.defaultProps = {
    position: 'relative',
    px: 2,
}

ContainerLg.defaultProps = {
    position: 'relative',
    px: 2,
}

ContainerMd.defaultProps = {
    position: 'relative',
    px: 2,
}

ContainerSm.defaultProps = {
    position: 'relative',
    px: 2,
}
